import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
@Component
export default class AssessmentPaper extends Vue {
  @Prop() public data!: any
  @Prop({
    default() {
      return true
    }
  })
  public bordered!: boolean

  public get curModule() {
    return this.$route.meta && this.$route.meta.section
  }

  public publish() {
    this.$emit('publish', this.data)
  }
  public preview() {
    this.$emit('preview', this.data)
  }
}
